// extracted by mini-css-extract-plugin
export var promoBlade = "PromoBlade-module--promo-blade--H1DwX";
export var content = "PromoBlade-module--content--ZhI2C";
export var screenshotWrapper = "PromoBlade-module--screenshot-wrapper--hxahS";
export var screenshot = "PromoBlade-module--screenshot--9nM4h";
export var backgroundGradients = "PromoBlade-module--background-gradients--dFX2K";
export var black1 = "PromoBlade-module--black-1--HwIN+";
export var yellow1 = "PromoBlade-module--yellow-1--XO4QK";